if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			// drawer cart connections

			const sidebarCart = document.getElementById('site-cart-sidebar');

			if ( document.getElementById('cart-open-button') ) {
				const cartButton = document.getElementById('cart-open-button');
				cartButton.addEventListener('click', e=>{
					e.preventDefault();
					cartButton.setAttribute('aria-expanded', 'true');
					sidebarCart.show(cartButton);
				})
				cartButton.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						// Focus will be handled by the show method
						// No need for special keyboard handling here
					}
				})
			}

			// drawer menu connection

			const sidebarMenu = document.getElementById('site-menu-sidebar');
			sidebarMenu.innerHTML = this.querySelector('[data-js-site-navigation-content]').innerHTML;
			if ( ! Shopify.designMode ) {
				this.querySelector('[data-js-site-navigation-content]').remove();
			}
			
			if ( document.getElementById('menu-open-button') ) {
				const menuButton = document.getElementById('menu-open-button');
				menuButton.addEventListener('click', e=>{
					e.preventDefault();
					menuButton.setAttribute('aria-expanded', 'true');
					sidebarMenu.show(menuButton);
				});
				menuButton.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						// Focus will be handled by the show method
						// No need for special keyboard handling here
					}
				});
			}

			// search drawer connection

			const sidebarSearch = document.getElementById('site-search-sidebar');

			if ( document.getElementById('search-open-button') ) {
				const searchButton = document.getElementById('search-open-button');
				searchButton.addEventListener('click', (function(e){
					e.preventDefault();
					searchButton.setAttribute('aria-expanded', 'true');
					sidebarSearch.show(searchButton);
				}).bind(this));
			}

			// closing drawers

			document.querySelectorAll('.sidebar__close button.close-sidebar').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.page-overlay').addEventListener('click', e=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			this.RESIZE_SidebarHelper = debounce(()=>{
				if ( document.querySelector('.sidebar--opened') )
					document.querySelector('.sidebar--opened').style.height = window.innerHeight + 'px';
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);

			// _end of drawers

			/* -- > STICKY SIDEBAR < -- */

			this.mountStickyHeader();
			
			/* -- > NAVIGATION < -- */

			const sidebarMenus = document.querySelector('.sidebar__menus');
			const closeButton = document.querySelector('#site-menu-sidebar button.close-sidebar');

			document.querySelectorAll('.sidebar__menus .sidebar__menu .has-submenu > .submenu-title').forEach(elm => {
				elm.addEventListener('click', e => {
					const listItem = e.currentTarget.closest('li');
					const submenu = listItem.querySelector('.sidebar__submenu');
					const isExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
					
					// Close all other open submenus
					document.querySelectorAll('.sidebar__menu .has-submenu > .submenu-title[aria-expanded="true"]').forEach(openMenu => {
						if (openMenu !== e.currentTarget) {
							openMenu.setAttribute('aria-expanded', 'false');
							openMenu.closest('li').classList.remove('submenu-active');
							openMenu.closest('li').querySelector('.sidebar__submenu').classList.remove('is-active');
						}
					});

					// Toggle this submenu
					e.currentTarget.setAttribute('aria-expanded', !isExpanded);
					listItem.classList.toggle('submenu-active', !isExpanded);
					submenu.classList.toggle('is-active', !isExpanded);
				});
				elm.addEventListener('keydown', e => {
					if ( e.key === 'Enter' || e.key === ' ' ) {
						e.preventDefault();
						e.currentTarget.click();
					}
				});
			});

			// Keep submenu open if it contains the active item
			document.querySelectorAll('.sidebar__submenu a.selected').forEach(selectedItem => {
				const parentSubmenu = selectedItem.closest('.has-submenu');
				if (parentSubmenu) {
					const submenuTitle = parentSubmenu.querySelector('.submenu-title');
					submenuTitle.setAttribute('aria-expanded', 'true');
					parentSubmenu.classList.add('submenu-active');
					parentSubmenu.querySelector('.sidebar__submenu').classList.add('is-active');
				}
			});

			// Collapse open submenus when the drawer closes
			closeButton.addEventListener('click', () => {
				document.querySelectorAll('.sidebar__menu .has-submenu > .submenu-title[aria-expanded="true"]').forEach(link => {
					link.setAttribute('aria-expanded', 'false');
					link.closest('li').classList.remove('submenu-active');
					link.closest('li').querySelector('.sidebar__submenu').classList.remove('is-active');
				});
			});

			/* -- > CENTERED NAV DROPDOWNS (SAME PATTERN AS SIDEBAR) < -- */
			
			// Setup centered nav dropdowns with HOVER + CLICK (like a pro would do it)
			const setupCenteredNav = () => {
				const centeredNavItems = document.querySelectorAll('.header__nav-center .has-submenu');
				
				if (centeredNavItems.length === 0) return;
				
				centeredNavItems.forEach(item => {
					const title = item.querySelector('.submenu-title');
					const submenu = item.querySelector('.nav-submenu, .sidebar__submenu');
					
					if (!title || !submenu) return;
					
					// Function to update dropdown position when sticky
					const updateDropdownPosition = () => {
						const header = document.querySelector('.mount-header');
						if (header && header.classList.contains('is-sticky')) {
							const rect = item.getBoundingClientRect();
							const titleRect = title.getBoundingClientRect();
							submenu.style.top = `${titleRect.bottom}px`;
							submenu.style.left = `${rect.left + (rect.width / 2)}px`;
							submenu.style.transform = 'translateX(-50%)';
						} else {
							// Reset to default positioning
							submenu.style.top = '';
							submenu.style.left = '';
							submenu.style.transform = '';
						}
					};
					
					// HOVER functionality (primary for desktop)
					item.addEventListener('mouseenter', () => {
						// Update position before showing
						updateDropdownPosition();
						
						// Close all other submenus
						document.querySelectorAll('.header__nav-center .has-submenu').forEach(otherItem => {
							if (otherItem !== item) {
								const otherTitle = otherItem.querySelector('.submenu-title');
								if (otherTitle) {
									otherTitle.setAttribute('aria-expanded', 'false');
								}
							}
						});
						
						// Open this submenu
						title.setAttribute('aria-expanded', 'true');
					});
					
					item.addEventListener('mouseleave', () => {
						// Close submenu
						title.setAttribute('aria-expanded', 'false');
					});
					
					// CLICK functionality (for accessibility/mobile)
					title.addEventListener('click', e => {
						e.preventDefault();
						e.stopPropagation();
						
						const isExpanded = title.getAttribute('aria-expanded') === 'true';
						
						if (!isExpanded) {
							// Update position before showing
							updateDropdownPosition();
						}
						
						// Close all other submenus
						document.querySelectorAll('.header__nav-center .has-submenu .submenu-title').forEach(otherTitle => {
							if (otherTitle !== title) {
								otherTitle.setAttribute('aria-expanded', 'false');
							}
						});
						
						// Toggle this submenu
						title.setAttribute('aria-expanded', !isExpanded);
					});
				});

				// Keep submenu open if it contains the active item
				document.querySelectorAll('.header__nav-center .nav-submenu a.selected, .header__nav-center .sidebar__submenu a.selected').forEach(selectedItem => {
					const parentSubmenu = selectedItem.closest('.has-submenu');
					if (parentSubmenu) {
						const submenuTitle = parentSubmenu.querySelector('.submenu-title');
						if (submenuTitle) {
							submenuTitle.setAttribute('aria-expanded', 'true');
						}
					}
				});
				
				// Close dropdowns when clicking outside
				document.addEventListener('click', (e) => {
					if (!e.target.closest('.header__nav-center .has-submenu')) {
						document.querySelectorAll('.header__nav-center .submenu-title[aria-expanded="true"]').forEach(title => {
							title.setAttribute('aria-expanded', 'false');
						});
					}
				});
			};
			
			// Run immediately and also after a delay to catch late-rendered elements
			setupCenteredNav();
			setTimeout(setupCenteredNav, 100);

		}

		mountStickyHeader() {

			this.siteHeaderParent = document.querySelector('.mount-header');

			if ( this.dataset.sticky === 'sticky--scroll' ) {

				window.lst = window.scrollY;
				window.lhp = 0;
				window.sot = 0;

				this.SCROLL_StickyHelper = () =>{

					var st = window.scrollY;

					if ( st == 0 || st <= window.sot  ) {
						this.siteHeaderParent.classList.remove('is-sticky');
						this.siteHeaderParent.classList.remove('is-colorful');
						this.siteHeaderParent.classList.remove('is-animating');
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 ) {
						return;	
					}
					if ( st > window.lhp ) {
						if ( st == 0 && this.siteHeaderParent.classList.contains('is-sticky') ) {
							this.siteHeaderParent.classList.remove('is-sticky');
							this.siteHeaderParent.classList.remove('is-colorful');
							this.siteHeaderParent.classList.remove('is-animating');
						} else if ( st <= lst && ! this.siteHeaderParent.classList.contains('is-sticky') ) {
							window.lhp = this.offsetTop;
							if ( Math.abs(this.siteHeaderParent.getBoundingClientRect().top) > this.siteHeaderParent.offsetHeight ) {
								window.sot = this.offsetTop > 0 ? this.offsetTop : window.sot;
								this.siteHeaderParent.classList.add('is-sticky');
								this.siteHeaderParent.classList.add('is-colorful');
								this.siteHeaderParent.classList.add('is-animating');
							}
						} else if ( st > lst && this.siteHeaderParent.classList.contains('is-sticky') ) {
							this.siteHeaderParent.classList.remove('is-sticky');
							this.siteHeaderParent.classList.remove('is-colorful');
							this.siteHeaderParent.classList.remove('is-animating');
						}
						
					}

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

			} else if ( this.dataset.sticky === 'sticky' ) {
				this.siteHeaderParent.classList.add('is-sticky');
				this.siteHeaderParent.classList.add('is-sticky-always');
				if ( this.dataset.stickyBackground == 'true' ) {
					this.siteHeaderParent.classList.add('is-sticky-always-without-margin');
					this.siteHeaderParent.classList.add('is-colorful');
				}
			}

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
			window.removeEventListener('scroll', this.SCROLL_StickyHelper);
		}

		focusFirstMeaningfulElement(sidebar) {
			// Improved focus flow following Universal Design Principle 3 (Simple & Intuitive)
			const cartHolder = sidebar.querySelector('.cart-holder');
			const hasItems = cartHolder && cartHolder.getAttribute('data-items') !== '0';
			
			// 1. First, check for cart heading/title
			const cartHeading = sidebar.querySelector('h2, [role="heading"], .cart-title, .site-cart-heading');
			if (cartHeading && cartHeading.getAttribute('tabindex') !== '-1') {
				cartHeading.setAttribute('tabindex', '-1'); // Make temporarily focusable
				cartHeading.focus();
				return;
			}
			
			if (hasItems) {
				// 2. For non-empty cart, focus on primary action
				const checkoutButton = sidebar.querySelector('#CheckOut, button[name="checkout"], .checkout-button');
				if (checkoutButton) {
					checkoutButton.focus();
					// Announce additional context for screen readers
					this.announceContext(`${cartHolder.getAttribute('data-items')} items in cart. Checkout button focused.`);
					return;
				}
				
				// 3. Alternative: First product for review
				const firstProductLink = sidebar.querySelector('.cart-item__title a, .cart-item h3 a, .cart-item a');
				if (firstProductLink) {
					firstProductLink.focus();
					return;
				}
			} else {
				// 4. Empty cart: Focus on continue shopping
				const continueButton = sidebar.querySelector('.cart-continue a, .button--continue');
				if (continueButton) {
					continueButton.focus();
					this.announceContext('Cart is empty. Continue shopping button focused.');
					return;
				}
			}
			
			// Fallback to close button
			const closeButton = sidebar.querySelector('.close-sidebar');
			if (closeButton) {
				closeButton.focus();
			}
		}

		// Add context announcement method
		announceContext(message) {
			const screenReaderInfo = document.getElementById('screen-reader-info');
			if (screenReaderInfo && message) {
				screenReaderInfo.textContent = message;
				setTimeout(() => {
					screenReaderInfo.textContent = '';
				}, 3000);
			}
		}

	}

	if (typeof customElements.get("main-header") == "undefined") {
		customElements.define("main-header", MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('.close-sidebar')?.addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(triggerElement = null){

			this.opened = true;

			if ( this.id == 'site-cart-sidebar' ) {
				const cartViewEvent = this.querySelector('[data-js-cart-view-event]');
				if ( cartViewEvent && typeof cartViewEvent.dispatchViewEvent === 'function' ) {
					cartViewEvent.dispatchViewEvent();
				}
			}

			// Store the trigger element for focus restoration when closing
			this.triggerElement = triggerElement || document.activeElement;
			
			// Store scroll position before locking body (for position: fixed)
			this.savedScrollPosition = window.scrollY;
			document.body.style.top = `-${this.savedScrollPosition}px`;
			
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = 'block';
			
			// Reset sidebar scroll position to top for better UX
			this.scrollTop = 0;
			
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				this.style.height = window.innerHeight + 'px';
				
				// Ensure scroll position is at top after animation
				this.scrollTop = 0;
				
				this._mountA11YHelper();
				
				// Announce to screen readers
				this.announceToScreenReader();
				
				// Always handle focus management for better accessibility
				setTimeout(() => {
					if (this.id === 'site-cart-sidebar') {
						const mainHeader = document.querySelector('main-header');
						if (mainHeader && typeof mainHeader.focusFirstMeaningfulElement === 'function') {
							mainHeader.focusFirstMeaningfulElement(this);
						}
					} else if (this.id === 'site-menu-sidebar') {
						const firstMenuLink = this.querySelector('.sidebar__menu a');
						if (firstMenuLink) {
							firstMenuLink.focus();
						} else {
							this.querySelector('.close-sidebar')?.focus();
						}
					} else if (this.id === 'site-search-sidebar') {
						const searchInput = this.querySelector('[data-js-search-input]');
						if (searchInput) {
							searchInput.focus();
						} else {
							this.querySelector('.close-sidebar')?.focus();
						}
					}
				}, 100);
			}, 15);

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			
			// Restore scroll position after unlocking body
			document.body.style.top = '';
			if (typeof this.savedScrollPosition === 'number') {
				window.scrollTo(0, this.savedScrollPosition);
			}
			
			this._unmountA11YHelper();

			// Update aria-expanded attributes
			if ( this.id == 'site-cart-sidebar' ) {
				const cartButton = document.getElementById('cart-open-button');
				if (cartButton) {
					cartButton.setAttribute('aria-expanded', 'false');
				}
			} else if ( this.id == 'site-search-sidebar' ) {
				const searchButton = document.getElementById('search-open-button');
				if (searchButton) {
					searchButton.setAttribute('aria-expanded', 'false');
				}
			} else if ( this.id == 'site-menu-sidebar' ) {
				const menuButton = document.getElementById('menu-open-button');
				if (menuButton) {
					menuButton.setAttribute('aria-expanded', 'false');
				}
			}

			// Reset page scroll position to top for better UX, especially when sidebar was opened from footer area
			setTimeout(() => {
				// Only scroll to top if user is in the lower portion of the page (footer area)
				const scrollPosition = window.scrollY;
				const windowHeight = window.innerHeight;
				const documentHeight = document.documentElement.scrollHeight;
				const distanceFromBottom = documentHeight - (scrollPosition + windowHeight);
				
				// If user is within 500px of the bottom (footer area), scroll to top
				if (distanceFromBottom < 500 || scrollPosition > documentHeight * 0.7) {
					window.scrollTo({ 
						top: 0, 
						behavior: 'smooth' 
					});
				}
			}, 200);

			// Restore focus to the trigger element for better A11Y
			setTimeout(() => {
				if (this.triggerElement && typeof this.triggerElement.focus === 'function') {
					// Check if the trigger element is still in the DOM and focusable
					if (document.contains(this.triggerElement)) {
						this.triggerElement.focus();
					}
				}
				// Clear the stored trigger element
				this.triggerElement = null;
			}, 100);

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

		announceToScreenReader() {
			const screenReaderInfo = document.getElementById('screen-reader-info');
			if (screenReaderInfo) {
				let message = '';
				if (this.id === 'site-cart-sidebar') {
					const cartHolder = this.querySelector('.cart-holder');
					const hasItems = cartHolder && cartHolder.getAttribute('data-items') !== '0';
					if (hasItems) {
						const itemCount = cartHolder.getAttribute('data-items');
						message = `Shopping cart opened. ${itemCount} item${itemCount !== '1' ? 's' : ''} in cart.`;
					} else {
						message = 'Shopping cart opened. Cart is empty.';
					}
				} else if (this.id === 'site-menu-sidebar') {
					message = 'Navigation menu opened.';
				} else if (this.id === 'site-search-sidebar') {
					message = 'Search opened.';
				}
				
				if (message) {
					screenReaderInfo.textContent = message;
					setTimeout(() => {
						screenReaderInfo.textContent = '';
					}, 2000);
				}
			}
		}

		/*
			* a11y helpers / tab catcher 
		*/

		_mountA11YHelper(forcedFocus){

			let focusable = forcedFocus ? forcedFocus : this.querySelectorAll('[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover');

			let firstFocusable = focusable[0];
			let lastFocusable = focusable[focusable.length - 1];

			// Special handling for cart sidebar to improve accessibility
			if ( this.id == 'site-cart-sidebar' ) {
				const cartHolder = this.querySelector('.cart-holder');
				const hasItems = cartHolder && cartHolder.getAttribute('data-items') != '0';
				
				if (hasItems) {
					// Look for cart footer buttons (add-on products) - these should be last in tab order
					const cartFooterButtons = this.querySelectorAll('.cart-footer-sidebar .cart-footer__add-button');
					
					if (cartFooterButtons.length > 0) {
						// If there are cart footer buttons, make the last one the final focusable element
						lastFocusable = cartFooterButtons[cartFooterButtons.length - 1];
					} else {
						// Fallback to checkout/view cart buttons
						const checkoutButton = this.querySelector('#CheckOut, button[name="checkout"]');
						const viewCartButton = this.querySelector('#ViewCart');
						
						if (checkoutButton) {
							const checkoutIndex = Array.from(focusable).indexOf(checkoutButton);
							if (checkoutIndex > -1) {
								lastFocusable = checkoutButton;
							}
						} else if (viewCartButton) {
							const viewCartIndex = Array.from(focusable).indexOf(viewCartButton);
							if (viewCartIndex > -1) {
								lastFocusable = viewCartButton;
							}
						} else {
							// Original logic for non-empty cart
							lastFocusable = focusable[focusable.length - 2];
						}
					}
				}
			}

			this.A11Y_TAB_EVENT = ((firstFocusable, lastFocusable, e)=>{
				let isTabPressed = (e.key === 'Tab' || e.keyCode === window.KEYCODES.TAB);
				if (!isTabPressed) { 
					return; 
				}
				if ( e.shiftKey ) /* shift + tab */ {
					if (document.activeElement === firstFocusable) {
						lastFocusable.focus();
						e.preventDefault();
					}
				} else /* tab */ {
					if (document.activeElement === lastFocusable) {
						firstFocusable.focus();
						e.preventDefault();
					}
				}
			}).bind(this, firstFocusable, lastFocusable)

			this.addEventListener('keydown', this.A11Y_TAB_EVENT);

		}

		_unmountA11YHelper(){
			this.removeEventListener('keydown', this.A11Y_TAB_EVENT);
		}

	}

	if (typeof customElements.get("sidebar-drawer") == "undefined") {
		customElements.define("sidebar-drawer", SidebarDrawer);
	}

}